import Vue from 'vue'

const FlashMessages = new Vue()

export default FlashMessages
